import React, {Component} from 'react'

import Popup from '../Popup/index';
import BecomeXXLPopup from '../BecomeXXLPopup/index';
import BlockPopup from '../BlockPopup/index';
import UnblockPopup from '../UnblockPopup/index';
import ExcludePopup from '../ExcludePopup/index';

import Registry from '../../../registry/index';

import itemVisible from './itemVisible';
import itemEnabled from './itemEnabled';
import AnonymousLoginPopup from "../AnonymousLoginPopup";

class UserContextMenu extends Popup {
    action(event, name) {
        if (typeof this[name] == "function") {
            event.preventDefault();
            this[name].call(this, Array.prototype.slice.call(arguments, 2));
        }
        this.close();
    }

    view() {
        let {user, openVideoWindow} = this.props;

        openVideoWindow(user.ufrag);
    }

    pm() {
        let {user, currentUser} = this.props;
        if (currentUser.isAnonymous()) {
            AnonymousLoginPopup.openAndSwitchTab(0);
        } else {
            UserContextMenu.pm(user, currentUser);
        }
    }

    _gifts_anonymous(event) {
        let {currentUser} = this.props;

        if (currentUser.isAnonymous()) {
            event.preventDefault();
            AnonymousLoginPopup.open();
            this.close();
        }
    }

    follow() {
        const {currentUser, user} = this.props;
        const siteInterface = Registry.get('siteInterface');

        if (currentUser.isAnonymous()) {
         AnonymousLoginPopup.open()
        }

        siteInterface.follow(user);
        this.close();
    }

    unfollow() {
        const {user} = this.props;
        const siteInterface = Registry.get('siteInterface');
        siteInterface.unfollow(user);
        this.close();
    }

    block() {
        let {currentUser, user} = this.props;

        if (currentUser.isAnonymous()) {
            AnonymousLoginPopup.open();
        } else if (!currentUser.isXXL()) {
            BecomeXXLPopup.open("block")
        } else BlockPopup.open({user});
    }

    unblock() {
        if (!this.props.currentUser.isXXL()) {
            BecomeXXLPopup.open("block")
        } else UnblockPopup.open({user: this.props.user});
    }

    ban(url) {
        window.open(url, "ban", "height=600,width=640")
    }

    revoke() {
        this.props.dispatch({
            type: "PM_ACTION_REVOKE_PERMISSION",
            conversation_uid: this.props.user.uid
        });
    }

    deleteHistory() {
        this.props.dispatch({
            type: "PM_ACTION_DELETE_HISTORY",
            conversation_uid: this.props.user.uid
        });
    }

    exclude() {
        let { user, currentUser, currentRoom } = this.props;
        ExcludePopup.open({ user, currentUser, currentRoom });
    }

    mention() {
        let roomEditorInstanceId = Registry.get('roomEditorInstance_id');
        let roomEditorInstance = Registry.get(roomEditorInstanceId);
        roomEditorInstance.insertMention(this.props.user.nick);
    }

    itemVisible(action, user, currentUser) {
        return itemVisible(action, user, currentUser);
    }

    itemEnabled(action, user, currentUser) {
        return itemEnabled(action, user, currentUser);
    }

    getAllItems(lang, user, currentRoom) {
        return {
            view: {
                onClick: (event) => this.action(event, 'view'),
                label: lang.watch
            },
            mention: {
                onClick: (event) => this.action(event, "mention"),
                label: '@' + user.nick
            },
            profile: {
                href: lang.path + user.getProfileURL(),
                target: '_blank',
                label: lang.view_profile
            },
            pm: {
                onClick: (event) => this.action(event, "pm"),
                label: lang.private_message
            },
            revoke: {
                onClick: (event) => this.action(event, "revoke"), 
                label: lang.revoke_pm
            },
            follow: {
                onClick: (event) => this.action(event, "follow"),
                label: lang.follow
            },
            unfollow: {
                onClick: (event) => this.action(event, "unfollow"),
                label: lang.unfollow
            },
            virtual_gift: {
                href: lang.path + user.getGiveVirtualGiftURL(),
                onClick: (event) => this._gifts_anonymous(event),
                target: '_blank',
                label: lang.give_virtual_gift
            },
            give_xxl: {
                href: lang.path + user.getGiveXXLURL(),
                onClick: (event) => this._gifts_anonymous(event),
                target: '_blank',
                label: lang.give_xxl
            },
            block: {
                onClick: (event) => this.action(event, "block"),
                label: lang.block
            },
            unblock: {
                onClick: (event) => this.action(event, "unblock"),
                label: lang.unblock
            },
            exclude: {
                onClick: (event) => this.action(event, "exclude"),
                label: lang.exclude
            },
            ban: {
                onClick: (event) => this.action(event, "ban", lang.path + user.getBanURL()),
                label: lang.ban
            },
            deleteHistory: {
                onClick: (event) => this.action(event, "deleteHistory"),
                label: lang.deleteHistory
            }
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }
}

UserContextMenu.pm = function(user, currentUser) {
    if (!currentUser.isAnonymous() && !currentUser.isXXL()) {
        BecomeXXLPopup.open("pm");
        return false;
    }

    let PMRequestSendingAllowed = (!currentUser.isUserBlocked(user) && !currentUser.isBeingBlocked(user));
    if (!PMRequestSendingAllowed) return false;

    let store = Registry.get('store');

    store.dispatch({
        type: "PM_SESSION_START",
        conversation_uid: user.uid
    });

};

export default UserContextMenu;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserContextMenu/index.js